<h2 mat-dialog-title>{{ 'administration.sync-monitoring.repair-dialog.title' | translate }}</h2>

<mat-dialog-content>
	<p class="repair-dialog-target">
		<span class="repair-dialog-label">{{ 'administration.sync-monitoring.reset-dialog.environment' | translate }}:</span>
		<strong>{{ data.environmentName }}</strong>
	</p>
	@if (data.repairNeeded.category) {
		<p class="repair-dialog-target">
			<span class="repair-dialog-label">{{ 'administration.sync-monitoring.repair-needed.finding' | translate }}:</span>
			<strong>{{ data.repairNeeded.category }}</strong>
		</p>
	}

	@if (isLoadingPreview) {
		<p class="repair-dialog-loading">
			<mat-progress-spinner diameter="18" mode="indeterminate" class="repair-dialog-spinner"></mat-progress-spinner>
			{{ 'administration.sync-monitoring.repair-dialog.loading' | translate }}
		</p>
	}

	@if (shown; as repair) {
		@if (hasNothingToRepair) {
			<p class="repair-dialog-info">{{ 'administration.sync-monitoring.repair-dialog.nothing-to-repair' | translate }}</p>
		}
		@if (repair.affectedTables?.length) {
			<p class="repair-dialog-target">
				<span class="repair-dialog-label">{{ 'administration.sync-monitoring.repair-needed.tables' | translate }}:</span>
				<strong>{{ repair.affectedTables?.join(', ') }}</strong>
			</p>
		}
		@if (repair.changes?.length) {
			<p class="repair-dialog-section">{{ 'administration.sync-monitoring.repair-dialog.changes' | translate }}</p>
			<ul class="repair-dialog-list">
				@for (change of repair.changes; track $index) {
					<li>{{ change }}</li>
				}
			</ul>
		}
		@if (repair.warnings?.length) {
			<p class="repair-dialog-section">{{ 'administration.sync-monitoring.repair-dialog.warnings' | translate }}</p>
			<ul class="repair-dialog-list repair-dialog-warning">
				@for (warning of repair.warnings; track $index) {
					<li>{{ warning }}</li>
				}
			</ul>
		}
		@if (repair.blockingReasons?.length) {
			<p class="repair-dialog-section">{{ 'administration.sync-monitoring.repair-dialog.blocked' | translate }}</p>
			<ul class="repair-dialog-list repair-dialog-error">
				@for (reason of repair.blockingReasons; track $index) {
					<li>{{ reason }}</li>
				}
			</ul>
		}
	}

	@if (data.repairNeeded.recommendedActionReason) {
		<p class="repair-dialog-note">{{ data.repairNeeded.recommendedActionReason }}</p>
	}
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button type="button" [disabled]="isApplying" (click)="onCancel()">
		{{ 'general.cancel' | translate }}
	</button>
	<button mat-flat-button color="primary" type="button" [disabled]="!canApply" (click)="onConfirm()">
		@if (isApplying) {
			<mat-progress-spinner diameter="18" mode="indeterminate" class="repair-dialog-spinner"></mat-progress-spinner>
		}
		{{ 'administration.sync-monitoring.repair-dialog.confirm' | translate }}
	</button>
</mat-dialog-actions>
